<template>
  <div class="application-page-header">
    <div class="page-title">{{ $t('privacy.' + $route.meta?.title) }}</div>
  </div>
  <div class="privacy-container">
    <p>
      {{
        $t(
          'privacy.This Privacy Notice provides information about the way Publicis Groupe (“the Groupe”, “We”) and each Publicis Company (“Agency”, “Employer”) uses and protects Personal Data of employees (“you”, “your Personal Data”) through an online talent management platform (“PROJECT ROAR”).'
        )
      }}
    </p>
    <h2>{{ $t('privacy.Introduction') }}</h2>
    <p>
      {{
        $t(
          'privacy.As part of Talent Management offerings, Publicis Groupe and your employer are introducing PROJECT ROAR, an online platform for career planning, capability assessment, promotion/transfer management across China. We take the protection of data privacy very seriously. Any data collected through PROJECT ROAR including Personal Data, will be treated as strictly confidential and will only be used for career development. Once collected, Personal Data will not be used for a different incompatible purpose. The applicable data protection laws shall be respected in full.'
        )
      }}
    </p>
    <div class="emphasize">
      {{
        $t(
          'privacy.If you have any questions about the collection of your data through PROJECT ROAR, please do not hesitate to contact your local HR/Talent contacts.'
        )
      }}
    </div>
    <h2>I. {{ $t('privacy.Purpose of data collection') }}</h2>
    <p>
      {{
        $t(
          'privacy.The purpose of collecting Personal Data through PROJECT ROAR is to provide a platform for career development and management in order to empower you to take the lead on your own development objectives and career aspirations.'
        )
      }}
    </p>
    <h2>
      II. {{ $t('privacy.What Personal Data do we collect and process?') }}
    </h2>

    <p>
      {{
        $t(
          'privacy.Personal Data means any information relating to an identified or identifiable natural person (i.e. living individual).'
        )
      }}
      {{ !isEn ? '我们在出狮行动平台中收集以下类别的个人信息：' : '' }}
    </p>
    <p v-if="isEn">
      <u>We collect the following categories of</u>
      <strong style="margin: 0 0.3em">Personal Data</strong>
      <u>in PROJECT ROAR:</u>
    </p>
    <ul>
      <li>
        <u>{{ $t('privacy.General Employee Information') }}</u>
        <div>
          {{
            $t(
              'privacy.We collect the following data in order to connect you and your manager: Employee LLID, Employee English Name, Employee Email, Employee Title, Review Manager Name (EN) ,Review Manager Email, Location, Brand, Role, Level, Department/Client, Parent Function, Child Function, Job Grading, Join Date.'
            )
          }}
        </div>
      </li>
      <li>
        <u>{{ $t('privacy.Home Tab') }}</u>
        <div>
          {{
            $t(
              'privacy.We will display on your Home Tab page your name, brand, job title, and manager name. This is visible only by you.'
            )
          }}
        </div>
      </li>
      <li>
        <u>{{ $t('privacy.Me Tab') }}</u>
        <div>
          {{
            $t(
              'privacy.In this section of the system, you can manage your ROAR Moment including application, status review.'
            )
          }}
        </div>
      </li>
      <li>
        <u>{{ $t('privacy.My Team Tab') }}</u>
        <div>
          {{
            $t(
              'privacy.This section is for managers only and allows them to have an overview of his/her whole team, assess and approve the team members who apply for ROAR Moment.'
            )
          }}
        </div>
      </li>
    </ul>

    <h2>III. {{ $t('privacy.With whom do we share your Personal Data?') }}</h2>
    <p>
      {{
        $t(
          'privacy.Your Personal Data is shared with the following internal parties of the Groupe and only to the extent required to meet the purposes as described in Section I on the purpose of data collection:'
        )
      }}
    </p>
    <ul>
      <li>
        {{
          $t(
            'privacy.All your data can be accessed by your local HRBP, HR Administrators. Local HR HRBP only have access to the business units/agencies they are responsible for. This is determined by the Country Chief Talent Officer.'
          )
        }}
      </li>
      <li>
        {{
          $t(
            'privacy.Your manager has only access to the information you add to this tool as per Section II.'
          )
        }}
      </li>
      <li>
        {{
          $t(
            'privacy.The administrators of the tool have access to all data in the tool.'
          )
        }}
      </li>
    </ul>

    <p v-if="isEn">
      We will
      <u>not disclose</u>
      your Personal Data to anyone else under any circumstances
      <u>except as otherwise stated in this Privacy Notice</u>
      and possibly to successors in title to our business, to establish,
      exercise or defend our rights, or where required by law.
    </p>
    <p v-else>
      在任何情况下，我们都不会向他人泄露您的个人信息，
      <u>除非本隐私声明中另有说明</u>
      ，有可能向我们业务的继任者提供，建立、行使或捍卫我们的权利、或应法律要求下提供。
    </p>
    <h2>IV. {{ $t('privacy.Who is processing your Personal Data?') }}</h2>
    <!-- prettier-ignore -->
    <p ref="owner">
      {{ $t('privacy.All maintenance of PROJECT ROAR is performed by') }}{{ !isEn ? '位于上海的阳狮集团完成，平台服务器也由其拥有' : '' }}<strong v-if="isEn"> the Publicis Groupe in Shanghai and is hosted on a server owned by Publicis Groupe in Shanghai(China)</strong>{{ $t('privacy.. If the services of third parties for the technical maintenance, administration or processing of data are required, your Personal Data will be accessed by these parties only to the extent that is required to ensure a smooth and secure technical handling of PROJECT ROAR. Any processing of the Personal Data by these parties will be done in accordance with our instructions, in compliance with applicable laws, and with respect to data confidentiality, privacy and security.')}}
    </p>
    <h2>
      V.
      {{
        $t(
          'privacy.Viewing, Editing, Updating or Deletion of your Personal Data'
        )
      }}
    </h2>
    <p>
      {{
        $t(
          'privacy.If you think that any of the Personal Data collected through and contained in PROJECT ROAR is incorrect, confusing or incomplete, please contact your HRBP to request that your Personal Data be edited, updated or deleted. You may also ask us to erase, restrict or port your Personal Data and you may tell us if you object to our use of your Personal Data.'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'privacy.Personal Data will be stored in PROJECT ROAR in accordance with any applicable data retention requirements and corporate policies.'
        )
      }}
    </p>

    <h2>VI. {{ $t('privacy.Data Security') }}</h2>
    <p>
      <strong>
        {{
          $t(
            'privacy.We use a variety of methods, such as firewalls, intrusion detection software and manual security procedures, to secure your Personal Data against loss or damage and to help protect the accuracy and security of your Personal Data and to prevent unauthorized access or improper use.'
          )
        }}
      </strong>
      {{
        $t(
          'privacy.If you think that PROJECT ROAR or any Personal Data is not secure or that there has been unauthorized access to PROJECT ROAR or to your Personal Data, please contact HRBP immediately.'
        )
      }}
    </p>
    <h2>VII. {{ $t('privacy.Confidentiality') }}</h2>
    <p>
      {{
        $t(
          'privacy.Please note that we treat your Personal Data as strictly confidential.'
        )
      }}
    </p>
    <h2>VIII. {{ $t('privacy.Data Transfers') }}</h2>
    <p>
      {{
        $t(
          'privacy.No Personal Data is transferred outside China except your manager is located outside of China. If a transfer is taking place, we ensure that those comply with applicable legal requirements.'
        )
      }}
    </p>
    <h2>IX. {{ $t('privacy.Notification of changes') }}</h2>
    <p>
      {{
        $t(
          'privacy.Should we wish to change this Privacy Notice and if you have already provided Personal Data through PROJECT ROAR, we will contact you to inform you of the new Privacy Notice and, in some circumstances, we may need to obtain your consent to the changes. In other circumstances, any such changes to this Privacy Notice will be promptly communicated on this page and you should check back to see whether there are any changes. Continued use of PROJECT ROAR after a change in the Privacy Notice indicates your acknowledgement and acceptance of the use of Personal Data in accordance with the amended Privacy Notice. If you wish to save this text, please mark the entire statement (e.g. with your mouse) and copy-paste by pushing ctrl-c.'
        )
      }}
    </p>
    <h2>X. {{ $t('privacy.Further Information') }}</h2>
    <p>
      {{
        $t(
          'privacy.For further information on PROJECT ROAR, please refer to your HRBP. If you consider that we are not complying with this Privacy Notice or if you have any questions in relation to this Privacy Notice, please contact your local HRBP.'
        )
      }}
    </p>
    <p style="margin-top: 48px">
      {{ $t('privacy.Last Update: 11 January 2022') }}
    </p>
  </div>
</template>

<script>
  import i18n from '@/locales'
  export default {
    name: 'Privacy',
    components: {},
    data() {
      return {}
    },
    methods: {},
    computed: {
      isEn() {
        return i18n.global.locale == 'en-US'
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .application-page-header {
    background-color: white;
    padding: 30px 32px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    .page-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }
  }
  .privacy-container {
    margin: @app-conetent-margin;
    background-color: white;
    padding: 8px 124px 8px 43px;
  }
  h2 {
    font-size: 15px;
    line-height: 20px;
    color: #333;
    font-weight: bold;
    margin-top: 48px;
  }
  p {
    font-size: 13px;
    line-height: 20px;
    color: #333;
    margin-top: 24px;
  }
  .emphasize {
    font-size: 13px;
    line-height: 20px;
    color: #333;
    font-weight: bold;
    margin-top: 24px;
  }
  ul {
    list-style: decimal;
    padding-left: 20px;
    li {
      margin-bottom: 1em;
    }
  }
</style>
